<template>
  <div class="chart">
    <!-- Show loader when loading -->
    <div v-if="loading">
      <div class="overlay" />
      <div class="loader">
        <v-icon>mdi-dots-circle</v-icon>
      </div>
    </div>

    <!-- Show chart if not loading and data is available -->
    <div v-else-if="value.length > 0">
      <apexchart
        ref="chart"
        :type="type"
        height="350"
        :options="chartOptions"
        :series="series"
      />
    </div>

    <!-- Show "No Data Available" if not loading and no data -->
    <div
      v-else
      class="no-data"
    >
      <h3>{{ title }}</h3>
      <div class="insideNoData">
        <span>No Data Available</span>
      </div>
      <!-- <div>No Data Available</div> -->
    </div>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import moment from "moment";
export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
    type: {
      type: String,
      default() {
        return "area";
      },
    },
    name: {
      type: String,
      default() {
        return "name";
      },
    },
    title: {
      type: String,
      default() {
        return "title";
      },
    },
    labels: {
      type: Array,
      default() {
        return [];
      },
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    xaxisType: {
      type: String,
      default() {
        return "datetime";
      },
    },
    xaxisText: {
      type: String,
      default() {
        return "xais text";
      },
    },
    yaxis: {
      type: Object,
      default() {
        return {};
      },
    },
    unit: {
      type: String,
      default() {
        return "";
      },
    },
    filter: {
      type: Array,
      default() {
        return [];
      },
    },
    dateFormat: {
      type: String,
      default() {
        return "DD-MMM-YYYY hh:mm:ss A";
      },
    },
    tooltipDateFormat: {
      type: String,
      default() {
        return "DD-MMM-YYYY hh:mm:ss A";
      },
    },
  },
  data() {
    return {
      options: {
        chart: {
          id: "area-datetime",
          type: "area",
          height: 350,
          zoom: {
            autoScaleYaxis: true,
          },
          toolbar: {
            tools: {
              pan: false,
            },
            export: {
              csv: {
                filename: "",
                headerCategory: "cat",
              },
              svg: {
                filename: "",
              },
              png: {
                filename: "",
              },
            },
          },
        },
        title: {
          text: "Title",
          align: "left",
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 2,
        },
        markers: {
          size: 0,
          style: "hollow",
        },
        yaxis: {},
        xaxis: {
          type: "datetime",
          tooltip: {
            enabled: false, // Disables the tooltip at the bottom on the x-axis
          },
          title: {
            text: "",
          },
          // format: this.dateFormat,
          tickAmount: 5,
          labels: {
            datetimeUTC: false,
          },
        },
        tooltip: {
          x: {},
        },
        // fill: {
        //   type: "gradient",
        //   gradient: {
        //     shadeIntensity: 1,
        //     opacityFrom: 0.7,
        //     opacityTo: 0.9,
        //     stops: [0, 100],
        //   },
        // },
      },
    };
  },
  computed: {
    series() {
      const sr = { name: this.title, data: this.value };
      return [sr];
    },
    chartOptions() {
      const opt = JSON.parse(JSON.stringify(this.options));
      opt.chart.type = this.type;
      opt.title.text = this.title;
      opt.colors = ["#23BDAA"];
      // opt.xaxis.categories = this.labels;
      if (this.value.length > 0) {
        opt.xaxis.type = this.xaxisType;
        opt.xaxis.title.text = this.xaxisText;
        opt.yaxis = this.yaxis;
        opt.yaxis.labels = {
          formatter: (v) => (v ? `${parseInt(v)} ${this.unit}` : `0 ${this.unit}`),
        };

        const dFormat = this.dateFormat;
        opt.xaxis.labels = {
          formatter: function (value) {
            return moment(value).format(dFormat);
          },
        };
        const ttFormat = this.tooltipDateFormat;
        opt.tooltip.x = {
          formatter: function (value) {
            return moment(value).format(ttFormat);
          },
        };

        opt.tooltip.y = {
          formatter: function (value) {
            if (this.title === 'Fuel Level' && Number.isNaN(value)) {
              return "N/A"; // Show "N/A" for Fuel Level when value is 0
            } else {
              return `${value} ${this.unit}`;
            } // Default formatting for other cases
          }.bind(this),
        };

        // file Name
        let fName = opt.chart.toolbar.export;
        const d =
          this.filter.length > 0
            ? `| ${this.filter[0]} - ${this.filter[1]}`
            : "";
        const name = `${this.name}-telematic-report | ${this.title} ${d}`;
        fName.csv.filename = name;
        fName.svg.filename = name;
        fName.png.filename = name;
        fName.csv.headerCategory = this.xaxisText;
      }
      return opt;
    },
  },
  methods: {},
};
</script>
<style lang="sass" scoped>
$poppinReg: 'Poppins Regular', sans-serif
$poppinMed: 'Poppins Medium', sans-serif
$poppinSemi: 'Poppins SemiBold', sans-serif
$poppinBold: 'Poppins Bold', sans-serif
.chart
    position: relative
    height: 100%
    min-height: 350px

@media only screen and (max-width: 600px)
  .chart
    min-height: 200px
    .overlay
        background: gray
        opacity: 15%
    .overlay, .loader
        position: absolute
        width: 100%
        height: 100%
        z-index: 5
        display: flex
        justify-content: center
        align-items: center

    .loader
        z-index: 10
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
        i
            font-size:  2.5rem
            animation: spin 2s infinite
@keyframes spin

    100%
        transform: rotate(360deg)


.no-data
  min-height: 350px
  .insideNoData
    background: url(../../assets/no-data-trips-small-laptop.svg)
    width: 100%
    display: flex
    flex-wrap: wrap
    background-size: contain
    height: 96%
    align-items: center
    justify-content: center
    span
      font-size: 1.4rem
      font-family: $poppinMed
      text-align: center
</style>